// extracted by mini-css-extract-plugin
export default {"fondo":"Nosotros_fondo__959eQ"};